/* eslint-disable array-callback-return */
import { CartLineModel } from "@insite/client-framework/Types/ApiModels"

interface DataLayerItem {
    item_id: string,
    item_name: string;
    item_brand: string,
    price?: number; 
    quantity: number | null,
    [key: string]: any;    
}

const generateSingleItemArray = (product: CartLineModel) => {
    const itemArr = [];
    const obj: DataLayerItem = {
        item_id: product.erpNumber ?? "",
        item_name: product.altText,
        item_brand: product.brand?.name || "",
        price: product.pricing?.unitNetPrice,
        quantity: product.qtyOrdered,
        vendor_name: product?.properties?.vendor ?? ""
    }

    const categoriesArr: string[] = (product.properties?.categories)?.split(",");
    let i = 1;
    if(categoriesArr[categoriesArr.length-1]===""){
        categoriesArr.pop();
    }
    if (categoriesArr.length !== 0) {
        const uniqueItems: Record<string, boolean> = {};
        for (const item of categoriesArr) {
            if(!uniqueItems[item]){
                if (i === 1) {
                    obj.item_category = item;
                    uniqueItems[item] = true;
                } else {
                    obj[`item_category${i}`] = item;
                    uniqueItems[item] = true
                }
                i++;
            }
        }
    }
    itemArr.push(obj)
    return itemArr
}

const generateMultipleItemArray = (products: CartLineModel[]) => {
    const itemArr: DataLayerItem[] = [];
    products.forEach(product => {

        const obj: DataLayerItem = {
            item_id: product.erpNumber ?? "",
            item_name: product.altText,
            item_brand: product.brand?.name || "",
            price: product.pricing?.unitNetPrice,
            quantity: product.qtyOrdered,
            vendor_name: product?.properties?.vendor ?? ""
        }
        const categoriesArr: string[] = (product.properties?.categories)?.split(",");
        let i = 1;
        if(categoriesArr[categoriesArr.length-1]===""){
            categoriesArr.pop();
        }
        if (categoriesArr.length !== 0) {
            const uniqueItems: Record<string, boolean> = {};
            for (const item of categoriesArr) {
                if(!uniqueItems[item]){
                    if (i === 1) {
                        obj.item_category = item;
                        uniqueItems[item] = true;
                    } else {
                        obj[`item_category${i}`] = item;
                        uniqueItems[item] = true
                    }
                    i++;
                }
            }
        }
        itemArr.push(obj);
    });
    return itemArr
}

const generateDataLayer: any = (items: DataLayerItem[] | null) => {
    const dataLayer = (window as any).dataLayer || [];
    if (dataLayer) {
        dataLayer.push({ ecommerce: null }); 
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                items
            },
        });
    }
    return dataLayer
}

export const addToCartDataLayer = (product: CartLineModel) => {
    const items = generateSingleItemArray(product)
    return generateDataLayer(items)
}

export const addAllToCartDataLayer = (productArray: CartLineModel[] | null) => {
    if(productArray){
        const items = generateMultipleItemArray(productArray);
        return generateDataLayer(items)
    }
}